<template>
  <div class="col-sm-6 col-lg-3 pd-5">
    <div class="card min-height card-hover-rise mb-0" :style="{ backgroundColor: statisticsItem[itemKey].background_color }">
      <div class="text-left card-head">
        <h5 class="px-1 pt-1 font-bold">{{ statisticsItem[itemKey].name }}</h5>
      </div>
      <div class="card-body d-flex justify-content-between align-items-center p-1">
        <div class="truncate">
          <h4 class="mb-25 font-bold text-left">
            {{ onlyCommaFormat(statisticsItem[itemKey].value) }} </h4>
          <div v-if="statisticsItem[itemKey].percentage_change">
            <span v-if="statisticsItem[itemKey].percentage_change > 0" class="text-success d-flex">
              <i class='fas fa-arrow-up arrow'></i>
              <p class="qcont mb-0 text-left">  {{ Math.abs(Number(statisticsItem[itemKey].percentage_change)) }} 
                % from last <span>{{ statisticsItem[itemKey].isMonth ? 'month' : 'day' }}</span>
              </p>
            </span>
            <span v-else class="text-danger d-flex"> 
              <i class='fas fa-arrow-down arrow'></i>
              <p class="qcont mb-0 text-left">  {{ Math.abs(Number(statisticsItem[itemKey].percentage_change)) }} 
                % from last <span>{{ statisticsItem[itemKey].isMonth ? 'month' : 'day' }}</span>
              </p>
            </span>
          </div>
        </div>
        <span >
          <span class="b-avatar-custom">
            <img id="img" :src="`/app-assets/images/icons/dashboard/${itemKey}.png`" alt="">
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script setup>
import figureFormatter from "@/services/utils/figureFormatter";

const {onlyCommaFormat} = figureFormatter()

defineProps({
  statisticsItem: Object,
  page: Object,
  itemKey: String
})

</script>

<style scoped>
.min-height {
  min-height: 150px;
}
.arrow {
  padding: 3px;
}
#img {
  width: 50px;
}
.truncate {
  h2 {
    font-size: 40px;
  }
}
.card-head {
  h2 {
    font-weight: bold;
  }
}
.card-hover-rise {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.card-hover-rise:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}
.font-bold {
  font-weight: bold;
}
</style>
